__turbopack_context__.v({
  "container": "CopyWithCta-module-scss-module__7O95sa__container",
});
